import { useTranslation } from "react-i18next";

export default function InterneLinks() {
  const { t } = useTranslation("kozijn-reparatie");
  const cards = t("links.cards", { returnObjects: true }) as Array<{
    title: string;
    desc: string;
    href: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("links.h2")}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <a
              key={i}
              href={card.href}
              className="group bg-white rounded-xl p-6 md:p-8 border border-brand-border hover:border-brand-yellow transition-colors"
            >
              <div className="flex items-center justify-between mb-3 md:mb-4">
                <h3 className="font-geist font-bold text-lg md:text-xl text-brand-text">
                  {card.title}
                </h3>
                <i className="ri-arrow-right-line text-brand-text/40 group-hover:text-brand-blue transition-colors w-5 h-5 flex items-center justify-center"></i>
              </div>
              <p className="font-geist text-sm md:text-base text-brand-text/70">
                {card.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}